/* Drukke Mama's variantafbeeldingen-filter (overgenomen uit de nieuwe template).
   Verving de StarApps "Variant Image Automator"-app toen diens script op
   5 okt 2026 leeg (404) werd geserveerd en de thumbnails niet meer filterde.

   Conventie: media staan in vaste volgorde.
   - Media vóór de featured image van de eerste variant zijn gedeeld.
   - Daarna per variant een aaneengesloten blok, van zijn featured image tot
     net vóór de featured image van de volgende variant.
   Bij een variantkeuze tonen we het gedeelde begin + het blok van die
   variant; de rest krijgt .dm-media-hidden (gallery, thumbnails, modal).

   Data komt uit #DmVariantMedia-<section>. Producten zonder varianten of
   zonder variantfoto's tonen alles. */
(function () {
  if (customElements.get('dm-variant-media')) return;

  class DmVariantMedia extends HTMLElement {
    connectedCallback() {
      const dataEl = document.getElementById(`DmVariantMedia-${this.dataset.section}`);
      if (!dataEl) return;
      try {
        this.config = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      this.featuredPositions = this.config.variants
        .map((variant) => variant.position)
        .filter((position) => position != null)
        .sort((a, b) => a - b);

      this.apply(this.config.selected);

      /* global.js (updateVariantInput) zet de verborgen input[name="id"] en
         dispatcht een bubbelend change-event bij elke variantwissel. */
      this.onVariantInput = (event) => {
        const input = event.target;
        if (!input || input.name !== 'id') return;
        if (!input.closest('form[action*="/cart/add"]')) return;
        this.apply(input.value);
      };
      document.addEventListener('change', this.onVariantInput);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantInput);
    }

    allowedMediaIds(variantId) {
      if (!this.featuredPositions.length) return null;
      const variant = this.config.variants.find((entry) => String(entry.id) === String(variantId));
      if (!variant || variant.position == null) return null;

      const start = variant.position;
      const next = this.featuredPositions.find((position) => position > start);
      const end = next == null ? Infinity : next;
      const firstFeatured = this.featuredPositions[0];

      const allowed = new Set();
      this.config.media.forEach((media) => {
        const isShared = media.position < firstFeatured;
        const inBlock = media.position >= start && media.position < end;
        if (isShared || inBlock) allowed.add(String(media.id));
      });
      return allowed;
    }

    apply(variantId) {
      const allowed = this.allowedMediaIds(variantId);
      if (allowed === null) return;
      const sectionId = this.dataset.section;

      const groups = [
        [document.getElementById(`Slider-Gallery-${sectionId}`), ':scope > li[data-media-id]'],
        [document.getElementById(`Slider-Gallery-${sectionId}-duplicate`), ':scope > li[data-media-id]'],
        [document.getElementById(`Slider-Thumbnails-${sectionId}`), ':scope > li[data-target]'],
        [document.getElementById(`Slider-Thumbnails-${sectionId}-duplicate`), ':scope > li[data-target]'],
        [document.getElementById(`ProductModal-${sectionId}`), '[data-media-id]'],
      ];

      groups.forEach(([scope, selector]) => {
        if (!scope) return;
        scope.querySelectorAll(selector).forEach((item) => {
          const raw = item.dataset.mediaId || item.dataset.target || '';
          const mediaId = raw.split('-').pop();
          item.classList.toggle('dm-media-hidden', !allowed.has(mediaId));
        });
      });

      this.updateSliders(sectionId);
    }

    updateSliders(sectionId) {
      [sectionId, `${sectionId}-duplicate`].forEach((suffix) => {
        const gallery = document.getElementById(`GalleryViewer-${suffix}`);
        if (gallery) {
          const visible = gallery.querySelectorAll('.product__media-item:not(.dm-media-hidden)').length;
          const total = gallery.querySelector('.slider-counter--total');
          if (total) total.textContent = visible;
          if (typeof gallery.resetPages === 'function') gallery.resetPages();
        }
        const thumbnails = document.getElementById(`GalleryThumbnails-${suffix}`);
        if (thumbnails && typeof thumbnails.resetPages === 'function') thumbnails.resetPages();
      });
    }
  }

  customElements.define('dm-variant-media', DmVariantMedia);
})();
